import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

const HamburgerIcon = ({
  color = '#B5BCBD',
  className,
  width = '21',
  ...props
}) => (
  <svg
    viewBox="0 0 21 15"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    {...props}
  >
    <g fill={color} fillRule="evenodd">
      <path d="M1.82 2.54h17.36c.682 0 1.24-.558 1.24-1.24 0-.682-.558-1.24-1.24-1.24H1.82C1.138.06.58.618.58 1.3c0 .682.558 1.24 1.24 1.24zM19.18 6.26H1.82c-.682 0-1.24.558-1.24 1.24 0 .682.558 1.24 1.24 1.24h17.36c.682 0 1.24-.558 1.24-1.24 0-.682-.558-1.24-1.24-1.24zM19.18 12.46H1.82c-.682 0-1.24.558-1.24 1.24 0 .682.558 1.24 1.24 1.24h17.36c.682 0 1.24-.558 1.24-1.24 0-.682-.558-1.24-1.24-1.24z" />
    </g>
  </svg>
);

HamburgerIcon.propTypes = propTypes;

export default HamburgerIcon;
